<div class="fu-container">
    <div class="top-row">
        <div class="name-container">
            <mat-icon
                data-cy="sys-status-selected-fu-cpu-icon"
                svgIcon="status-indicator"
                [ngClass]="{
                    alarm_status: hasAlarms() && isReceivingData,
                    disconnected_status: !isReceivingData,
                    stable_status: !hasAlarms() && isReceivingData,
                }"
            />
            {{ "system-status.fu.cpu" | translate }}
        </div>
    </div>
    <div class="status-container">
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.run) === 'status-error',
            }"
        >
            {{ "system-status.fu.run" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-run-icon"
                svgIcon="{{ getIcon(fuStatus.run) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.initialized) === 'status-error',
            }"
        >
            {{ "system-status.fu.initialized" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-init-icon"
                svgIcon="{{ getIcon(fuStatus.initialized) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.files) === 'status-error',
            }"
        >
            {{ "system-status.fu.files" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-files-icon"
                svgIcon="{{ getIcon(fuStatus.files) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.fieldbusA) === 'status-error',
            }"
        >
            {{ "system-status.fu.fieldbusA" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-fieldbus-a-icon"
                svgIcon="{{ getIcon(fuStatus.fieldbusA) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.fieldbusB) === 'status-error',
            }"
        >
            {{ "system-status.fu.fieldbusB" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-fieldbus-b-icon"
                svgIcon="{{ getIcon(fuStatus.fieldbusB) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
        <div
            class="status-wrapper"
            [ngClass]="{
                'alarm-font': getIcon(fuStatus.IO) === 'status-error',
            }"
        >
            {{ "system-status.fu.IO" | translate }}
            <mat-icon
                *ngIf="isReceivingData"
                data-cy="sys-status-selected-fu-cpu-io-icon"
                svgIcon="{{ getIcon(fuStatus.IO) }}"
                class="icon"
            />
            <div *ngIf="!isReceivingData" class="disconnected-line"></div>
        </div>
    </div>
</div>
